<template>
  <header v-if="isHeader" class="custom-header-title-container">
    <h1 class="custom-header-title" :class="brandClass"><slot name="title"></slot></h1>
    <div class="custom-header-subtitle" :class="brandClass"><slot name="subtitle"></slot></div>
    <div class="custom-header-description" :class="brandClass"><slot name="description"></slot></div>
  </header>
  <div v-else-if="isDiv" class="custom-header-title-container">
    <h1 class="custom-header-title" :class="brandClass"><slot name="title"></slot></h1>
    <div class="custom-header-subtitle" :class="brandClass"><slot name="subtitle"></slot></div>
    <div class="custom-header-description" :class="brandClass"><slot name="description"></slot></div>
  </div>
  <div v-else class="custom-header-title-container">
    <h2 class="custom-header-title internal" :class="brandClass"><slot name="title"></slot></h2>
    <div class="custom-header-subtitle internal" :class="brandClass"><slot name="subtitle"></slot></div>
    <div class="custom-header-description internal" :class="brandClass"><slot name="description"></slot></div>
  </div>
</template>

<script>
export default {
  name: 'OneHead',
  props: {
    brandClass:{
      type: String,
      required: false,
      default: '__b'
    },
    isHeader:{
      type: Boolean,
      default: true
    },
    isDiv:{
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
@import './styles/_fonts.scss';
@import './styles/_variables.scss';
#app{
  .custom-header-title {
    margin: 0;
    font-size: 32px;
    font-weight: 300;
    line-height: 40px;
    
    @media screen and (max-width: 768px) {
      font-size: 24px;
    }

    &.__m{
      font-weight: 700;
    }
    &.__t{
      font-family: ToyotaSemibold;
    }
    &.__alphera{
      font-family: TahomaAlpheraBold;
    }
    &.__rr{
      text-align: center;
      font-family: RivieraNights-Light;
      font-size: 30px;
      color: white;

      &.internal {
        text-align: left;
        font-size: 32px;
      }
    }
    &.__alphabet{
      font-family: AlphabetSlabPro-Light;
      color: $alphabetblue;
      font-weight: 100;
      text-transform: capitalize;
      &.__d{
        color: white;
      }
    }
    &.__motorrad{
      font-weight: bold;
    }
  }
  .custom-header-subtitle {
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    margin-top: 7px;

    @media screen and (max-width: 768px) {
      font-size: 14px;
    }

    a{
      font-weight: bold;
    }

    &.__alphabet{
      font-family: AlphabetSansPro-Medium;
      color: $alphabetblue;
      font-weight: 100;
      a{
        font-weight: 100;
        color: $alphabetblue;
      }
    }
    &.__rr{
      font-family: RivieraNights-Light;
      font-size: 15px;
      color: #BBBBBB;
       a {
         color: $rrlightblue;
       }

      &.internal {
        font-family: RivieraNights-Ultralight;
        color: rgba(white, 0.6);
        margin-top: 1rem;
      }
    }
    &.__motorrad{
      font-weight: 400;
      a{
        font-weight: normal;
      }
    }
  }
  .custom-header-description {
    p{
      font-weight: 300;
      font-size: 16px;
      line-height: 24px;
      padding-top: 10px;
    }
    &.__m{
      p{
        padding-top: 0px;
      }
    }
    &.__alphabet{
      p{
        color: $alphabetblue;
        font-family: AlphabetSansPro-Medium;
        font-weight: 100;
      }
    }
    &.__rr{
      font-family: RivieraNights-Light;
      color: $grey;
      a {
        color: $rrlightblue;
      }
      // font-family: Riviera Nights;
    }
  }
}

</style>


